<template>
  <div>
    <h2>Date-Based Task History</h2>
    <v-card>
      <v-data-table
        :items='this.dateBasedTasks'
        :items-per-page='options.itemsPerPage'
        :headers='headers'
        :loading="$wait.is(['loading completed date-based tasks'])"
        :footer-props.sync='footerProps'
        :options.sync='options'
      >
        <v-progress-linear v-slot:progress color='blue' indeterminate></v-progress-linear>
        <template v-slot:item='props'>
          <tr>
            <td>{{ props.item.completedDate | formatDate }}</td>
            <td>{{ props.item.description }}</td>
            <td>{{ props.item.completedAtHours }}</td>
            <td>{{ props.item.completedAtKilometres }}</td>
            <td>{{ props.item.completedBy }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import DateBasedTaskClient from '../DateBasedTasks/DateBasedTasksClient.vue';

export default {
  mixins: [
    DateBasedTaskClient
  ],
  data() {
    return {
      options: {
        itemsPerPage: 10,
        sortBy: ['name']
      },
      footerProps: {
        itemsPerPageOptions: [10, 50, 100]
      },
      headers: [
        { text: 'Completed Date', value: 'completedDate', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Completed At Hours', value: 'completedAtHours', sortable: false },
        { text: 'Completed At Kilometres', value: 'completedAtKilometres', sortable: false },
        { text: 'Completed By', value: 'completedBy', sortable: false }
      ],
      model: {},
      dateBasedTasks: []
    };
  },
  computed: {
    unitId() {
      return this.$route.params.unitId;
    },
    params() {
      return {
        pageSize: this.options && this.options.itemsPerPage,
        page: this.options && this.options.page,
        completed: true,
        orderBy: '-date',
        unitId: this.unitId,
        includeDeleted: true
      };
    }
  },
  async mounted() {
    await this.refreshDateBasedTasks();
  },
  methods: {
    async refreshDateBasedTasks() {
      this.$wait.start('loading completed date-based tasks');
      const tasks = await this.getDateBasedTaskHistoryForUnit(this.unitId);
      this.dateBasedTasks = tasks.filter((s) => !!s.completedDate);
      this.$wait.end('loading completed date-based tasks');
    }
  },
  watch: {
    async unitId(val) {
      await this.refreshDateBasedTasks();
    }
  }
};
</script>
<style>
td {
  cursor: pointer;
}
</style>
